import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

const BooksTable = ({
  books,
  getTracksByBooks,
  filterInput,
  setFilterInput,
  selectedRow,
  setSelectedRow,
  hasChanges,
  setHasChanges,
  handleInsertTracksByBook,
  tracksByBooks,
  setBookOptionSelected,
  setBookName,
  setSelectAll,
  setTracksByBooks,
}) => {
  const [filteredData, setFilteredData] = useState([]);

  //This useEffect filters the Books table according to Book Description
  useEffect(() => {
    let filtered = books;
    if (filterInput) {
      filtered = filtered.filter((item) =>
        item.Description.toLowerCase().includes(filterInput.toLowerCase()),
      );
    }
    setFilteredData(filtered);
  }, [books, filterInput]);

  // Headers
  let headers,
    tableBooks = [];
  headers = (
    <tr className="text-center" style={{ cursor: "default" }}>
      <th hidden>IDBook</th>
      <th style={{ width: "290px" }}>Book Name</th>
    </tr>
  );

  // This function displays the tracks associated with each book
  const showTracksByBook = (i, idBook, bookName) => {
    const loadTracks = () => {
      setSelectedRow(i);
      getTracksByBooks(idBook);
      setBookOptionSelected(idBook);
      setBookName(bookName);
      setSelectAll(false);
    };

    if (hasChanges) {
      Swal.fire({
        title: "Are you sure?",
        text: "Changes will be saved!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancel",
        confirmButtonText: "Yes, save it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          handleInsertTracksByBook(tracksByBooks, false);
          loadTracks();
        } else {
          setHasChanges(false);
          loadTracks();
        }
      });
    } else {
      loadTracks();
    }
  };

  // This function handles the book filter input change
  const handleInputFilterChange = (event) => {
    const loadTracks = () => {
      setFilterInput(value);
      setSelectedRow(null);
      setBookOptionSelected(null);
      setBookName("");
      setSelectAll(false);
      setHasChanges(false);
      setTracksByBooks([]);
    };
    const value = event.target.value;
    if (hasChanges) {
      Swal.fire({
        title: "Are you sure?",
        text: "Changes will be saved!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancel",
        confirmButtonText: "Yes, save it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          handleInsertTracksByBook(tracksByBooks, false);
        } else {
          loadTracks();
        }
      });
    } else {
      loadTracks();
    }
  };

  // The main Books table
  if (books) {
    tableBooks = filteredData.map((item, i) => {
      return (
        <React.Fragment key={i}>
          <tr
            key={item.IDBook}
            onClick={() => showTracksByBook(i, item.IDBook, item.Description)}
            className={selectedRow === i ? "shadedRow" : ""}
            style={{ cursor: "pointer" }}
          >
            <td key={"IDBook" + i} className="d-none">
              {item.IDBook}
            </td>
            {/* Book Name */}
            <td
              key={"Description" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "left",
                width: "290px",
                maxWidth: "290px",
              }}
            >
              <div
                title={item.Description}
                style={{
                  maxWidth: "290px",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {item.Description}
              </div>
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <p
          className="lead"
          style={{ color: "#8c8c8c", fontSize: "16px", cursor: "default" }}
        >
          Books List
        </p>
      </div>
      <div style={{ textAlign: "center" }}>
        <input
          value={filterInput}
          onChange={handleInputFilterChange}
          placeholder={"Book Search..."}
          className="form-control mb-1"
        />
      </div>
      <div style={{ overflow: "auto" }} className="tracksByBookTables">
        <table className="table table-hover table-sm mt-2">
          <thead
            style={{ position: "sticky", top: "0", background: "#d9d9d9" }}
          >
            {headers}
          </thead>
          <tbody className="table-lg">{tableBooks}</tbody>
        </table>
      </div>
    </div>
  );
};

export default BooksTable;
